module.exports = __webpack_public_path__ + "static/media/success_icon.77d21f5f.svg";